import classNames from 'classnames';
import { colors } from 'components/styles/variables';
import { formatNumberWithCommas } from 'lib/utils';

interface FacetCountProps {
  count: number;
  hasZeroFacets: boolean;
}

export default function FacetCount({ count, hasZeroFacets }: FacetCountProps): JSX.Element {
  return (
    <span className={classNames({ 'zero-facets': hasZeroFacets })}>
      {`(${formatNumberWithCommas(count)})`}
    </span>
  );
}

export const styles = `
  .zero-facets {
    color: ${colors.G2};
    cursor: not-allowed;
  }
`;
